import { defineMessages } from 'react-intl';

export default defineMessages({
    digitalAppName: {
        id: 'digital.appName',
        defaultMessage: 'Policyholder Portal'
    },
    signUp: {
        id: 'auth.components.LockLogin.Sign up',
        defaultMessage: 'Sign up'
    },
    doYouHavePolicy: {
        id: 'auth.components.LockLogin.Do you have a policy with us but don’t have an account?',
        defaultMessage: 'Do you have a policy with us but don’t have an account?'
    },
    registerPolicy: {
        id: 'ri.auth.components.LockLogin.Do you have a policy with us but don’t have an account?',
        defaultMessage: 'Do you have a policy with us but don’t have an account?'
    },
    helpNeeded: {
        id: 'ri.auth.components.LockLogin.Need Help? ',
        defaultMessage: 'Need help?'
    },
    legalDisclosures: {
        id: 'ri.auth.components.LockLogin.Legal Disclosure',
        defaultMessage: 'Legal Disclosures'
    },
    portalSupport: {
        id: 'ri.auth.components.LockLogin.Contact Portal Support',
        defaultMessage: 'Contact Portal Support'
    },
    allRightResv: {
        id: 'ri.auth.components.LockLogin.AllRightReserve.© 2001-2020 Republic Indemnity Company of America. All rights reserved.',
        defaultMessage: '© 2001-2020 Republic Indemnity Company of America. All rights reserved.'
    },
    riRegisterNow: {
        id: 'ri.auth.components.LockLogin.Register Now',
        defaultMessage: 'Register Now'
    },    

});
